import React from "react";
import Typography from "@material-ui/core/Typography";

const ResponseFromServer = ({ response }) => {
  return (
    <>
      {response && (
        <Typography variant="h5">
          איזה כיף שהשתתפת במבצע !
          מייל עם קוד קופון מפנק בדרך אליך♥️
          במידה ולא קיבלת בדקי אם הגיע לקידומי המכירות או לספאם.

          תתחדשי ותהני!
        </Typography>
      )}
      {!response && (
        <Typography variant="h5">
          חלה שגיאה . נסי שנית או פני אלינו בצור קשר
        </Typography>
      )}
    </>
  );
};

export default ResponseFromServer;